import { createConsumer } from "@rails/actioncable";
import { cableBaseURL } from "../../../globalUtils/axiosConfig";

export default createConsumer(cableBaseURL);
